import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import store from './redux/store';

import { GoogleOAuthProvider } from '@react-oauth/google';


const root = ReactDOM.createRoot(
  document.getElementById('root')
);


root.render(

  <React.StrictMode>

    <Provider store={store}>

      <GoogleOAuthProvider
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      >

        <BrowserRouter>

          <App />

        </BrowserRouter>

      </GoogleOAuthProvider>

    </Provider>

  </React.StrictMode>

);